export enum Colorscheme {
    light = 'bg-e-white',
    white = 'bg-white'
}
